import React from "react";
import { InvestmentViewContainer } from "../../../containers";

const InvestmentView = (props) => {
  return <InvestmentViewContainer {...props} />;
};

export default InvestmentView;
